import { useCallback } from 'react';
import {
  processarParcelaIndividual,
  calcularJurosManuais,
  calcularDesconto
} from '../utils/calculosUtils';

export const useCalculoPagamento = () => {
  // Função para processar uma única parcela
  const processarParcela = useCallback((parcela, regrasJuros, valoresPagamento, valoresCalculados, 
    tipoJuros, jurosPercentual, valorJurosFixo, tipoDesconto, descontoPercentual, valorDescontoFixo, aplicarJurosAutomaticos) => {
    
    try {
      // Verificar se o valor foi modificado manualmente
      const valorAtual = parseFloat(valoresPagamento[parcela.id]);
      const valorCalculadoAnteriormente = parseFloat(valoresCalculados[parcela.id]?.valorFinal);
      
      // Verifica se o valor foi modificado manualmente
      const modificadoManualmente = !isNaN(valorAtual) && 
                                  !isNaN(valorCalculadoAnteriormente) && 
                                  Math.abs(valorAtual - valorCalculadoAnteriormente) > 0.01;
      
      // Usa o valor manual se foi modificado, caso contrário, usa null para calcular
      const valorManual = modificadoManualmente ? valorAtual : null;
      
      if (modificadoManualmente) {
        console.log(`Mantendo valor manual para parcela ${parcela.id}: R$ ${valorAtual.toFixed(2)}`);
      }
      
      // Processa a parcela usando a função utilitária
      const resultado = processarParcelaIndividual({
        parcela,
        tipoJuros,
        jurosPercentual,
        valorJurosFixo,
        tipoDesconto,
        descontoPercentual,
        valorDescontoFixo,
        aplicarJurosAutomaticos,
        valorManual
      });
      
      // NOVO LOG: Inspeciona o objeto resultado completo retornado por processarParcelaIndividual
      console.log(`[useCalculoPagamento] Resultado de processarParcelaIndividual para ${parcela.id}:`, resultado);

      // Adiciona logs detalhados do cálculo
      if (resultado.detalhes && !resultado.detalhes.manual) {
        const { valorOriginal, jurosManuais, jurosAutomaticos, desconto, valorFinal } = resultado.detalhes;
        
        console.group(`Cálculo para parcela ${parcela.id}:`);
        console.log(`- Valor original: R$ ${valorOriginal !== undefined ? valorOriginal.toFixed(2) : 'N/A'}`);
        if (jurosManuais !== undefined && jurosManuais > 0) {
          console.log(`+ Juros manuais: R$ ${jurosManuais.toFixed(2)}`);
        }
        if (jurosAutomaticos !== undefined && jurosAutomaticos > 0) {
          console.log(`+ Juros automáticos: R$ ${jurosAutomaticos.toFixed(2)}`);
        }
        if (desconto !== undefined && desconto > 0) {
          console.log(`- Desconto: R$ ${desconto.toFixed(2)}`);
        }
        console.log(`= Valor final: R$ ${valorFinal !== undefined ? valorFinal.toFixed(2) : 'N/A'}`);
        console.groupEnd();
      }
      
      return resultado;
      
    } catch (error) {
      console.error(`Erro ao processar parcela ${parcela.id || 'sem ID'}:`, error);
      return { 
        id: parcela.id, 
        valorFinal: 0, 
        erro: error.message,
        detalhes: {
          valorOriginal: 0,
          jurosManuais: 0,
          jurosAutomaticos: 0,
          desconto: 0,
          valorFinal: 0,
          jurosManuaisPercentual: 0,
          jurosAutomaticosPercentual: 0,
          descontoPercentual: 0,
          erro: error.message
        }
      };
    }
  }, []);

  return {
    processarParcela,
    calcularJurosManuais,
    calcularDesconto
  };
};
